module.exports = __webpack_public_path__ + "img/queued-for-publish.a3305c8c.png";